import React from 'react';
import { Route, Redirect } from "react-router-dom";
import { authHelpers } from '../../auth/helpers/auth';

const UnauthenticatedRoute = ({ component: Component, ...rest }) => {
  let redirectLocation = (localStorage.getItem("redirectedFrom"));
  return (
    <Route {...rest} render ={props => (
      (!authHelpers.isUserAuthenticated()) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{
          pathname: redirectLocation,
          state: { from: props.location, isFromLogin: true }
        }}/>
      )
    )}/>
  )
};

export default UnauthenticatedRoute;